<div class="finx-table-root d-flex flex-col h-100 pointer-events-none" [ngStyle]="rootStyle">
  <!-- Search / toolbar -->
  <div
    *ngIf="enableSearch || dropdownAction?.isAllowDropdownAction"
    class="search-input finx-table-toolbar"
    [ngStyle]="tableToolbarHeaderStyle"
    [ngClass]="{ 'is-space-between': dropdownAction.isAllowDropdownAction }"
  >
    <div class="d-flex action-container w-100" *ngIf="dropdownAction.isAllowDropdownAction">
      <div
        class="action-dropdown"
        [style.width.%]="dropdownAction.dropdownWidth"
        *ngIf="dropdownAction?.isAllowDropdownAction"
      >
        <finxone-select-dropdown
          [optionLabelKey]="'label'"
          [optionValueKey]="'value'"
          [appendToBody]="true"
          [options]="dropdownOptions"
          [label]="dropdownAction.dropdownLabel"
          [selectedOption]="selectedOption?.label ?? ''"
          (selectionChange)="dropDownValueChange($event)"
        >
        </finxone-select-dropdown>
      </div>
      <div class="is-center" *ngIf="showConfirmButton">
        <finx-button
          class="w-100"
          [buttonStyle]="confirmButtonStyle"
          [labeltext]="actionButtonContent"
          (click)="onClickConfirmButton($event)"
        ></finx-button>
      </div>
    </div>

    <span class="search d-flex" [ngStyle]="searchInputStyle" *ngIf="enableSearch">
      <finxone-input
        type="text"
        [placeholder]="searchPlaceHolder"
        (input)="searchValue($event)"
        class="w-100"
      >
        <span prefix #prefix class="prefix-icon" *ngIf="searchIcon">
          <mat-icon [svgIcon]="searchIcon" [ngStyle]="searchIconStyle"></mat-icon>
        </span>
      </finxone-input>
    </span>
  </div>

  <div
    hlmTableContainer
    class="finx-table-scroll-area flex-grow-1"
    #tableTopAnchor
    [attr.id]="tableTopAnchorId"
  >
    <table
      hlmTable
      [ngClass]="
        (horizontalGridLinesEnabled ? 'finx-grid-lines-horizontal ' : '') +
        (verticalGridLinesEnabled ? 'finx-grid-lines-vertical ' : '') +
        (enableSearch || dropdownAction?.isAllowDropdownAction ? 'finx-has-toolbar ' : '') +
        (pagingEnabled && !!entityData?.length ? 'finx-has-paginator ' : '') +
        selectedTableSize
      "
    >
      <!-- Header -->
      <thead hlmTableHeader>
        <tr hlmTableRow [ngStyle]="getHeaderRowStyle()">
          <th hlmTableHead *ngIf="multipleSelectionAllowed && !!entityData?.length">
            <input
              type="checkbox"
              class="checkboxInput d-flex"
              [ngStyle]="
                selectedItemsFromHeaderCheckbox?.length === entityData?.length
                  ? checkboxStyles.checkboxActiveStyle
                  : checkboxStyles.checkboxInactiveStyle
              "
              [checked]="selectedItemsFromHeaderCheckbox?.length === entityData?.length"
              (change)="onHeaderCheckboxChange($event)"
            />
          </th>
          <th
            hlmTableHead
            *ngFor="let col of columns"
            [innerHTML]="col.label | safeHtml: false"
            [class.finx-action-col]="isExpandColumn(col)"
          ></th>
          <th hlmTableHead class="finx-action-col" *ngIf="isShowMoreOption" [ngStyle]="tableHeaderCss">
            &nbsp;
          </th>
          @if (listActions?.enableActionColumn) {
            <th hlmTableHead class="finx-action-col" [ngStyle]="tableHeaderCss">
              {{ listActions?.columnHeader }}
            </th>
          }
        </tr>
      </thead>

      <!-- Body -->
      <tbody hlmTableBody>
        <tr
          hlmTableRow
          class="position-relative"
          *ngFor="let rowData of entityData; let rowIndex = index"
          [ngStyle]="getRowStyle(rowData, rowIndex)"
          (click)="onClickRow($event, rowData)"
        >
          <td hlmTableCell *ngIf="multipleSelectionAllowed">
            <input
              type="checkbox"
              class="checkboxInput is-center"
              [ngStyle]="
                selectedItem.includes(rowData[uniqueId])
                  ? checkboxStyles.checkboxActiveStyle
                  : checkboxStyles.checkboxInactiveStyle
              "
              [checked]="selectedItem.includes(rowData[uniqueId])"
              [disabled]="rowData.status === 'failed' || rowData.status === 'reverted'"
              (change)="onRowCheckboxChange($event, rowData)"
            />
          </td>
          <div [outerHTML]="renderUserItem(rowData) | safeHtml: false"></div>
          @if (isShowMoreOption) {
            <td class="width-action-row finx-action-col position-relative">
              @if (rowData?.actionEnabled === false) {
                <div></div>
              } @else {
                <div class="more-icon" id="more-options" [ngStyle]="threeDotStyles">
                  <mat-icon
                    class="is-pointer"
                    (click)="moreOption(rowData[uniqueId], $event)"
                    svgIcon="more-img-option"
                  ></mat-icon>
                </div>
              }
            </td>
          }

          @if (isShowOption && isSelectedId === rowData[uniqueId]) {
            <div
              class="show-more-options"
              [ngStyle]="menuPopupCss"
              [style.top]="rowIndex === 0 || rowIndex === 1 ? '10px' : 'unset'"
              [style.bottom]="rowIndex === 0 || rowIndex === 1 ? 'unset' : '14px'"
              (clickOutside)="closeMenu()"
            >
              @for (link of actionOptions; track link.value) {
                @if (!link?.isIdNotExist || (link?.isIdNotExist && !rowData?.[link.isIdNotExist])) {
                  <span
                    class="is-pointer"
                    (click)="navigateTo(link.value, rowData[uniqueId], link)"
                    [ngClass]="{
                      disabled: rowData?.showMenuPopup ?? false,
                      'highlighted-option':
                        link.value?.includes('remove') ||
                        link.value?.includes('retry') ||
                        link.value?.includes('skip'),
                      'd-none':
                        menuItemsStatus && menuItemsStatus?.[rowData[uniqueId]]?.[link.value] === false,
                    }"
                  >
                    {{ link.label }}
                  </span>
                }
              }
            </div>
          }

          <!-- Action column -->
          @if (listActions?.enableActionColumn) {
            <td class="width-action-row finx-action-col">
              <div class="d-flex items-center" [ngStyle]="actionButtonStyle">
                @for (config of listActions?.actionsConfig; track config?.action) {
                  @if (config?.isActionSelected) {
                    <span
                      class="cursor-pointer"
                      [ngClass]="config.linkToGlobalStyling ? config.class : ''"
                      [innerHTML]="renderHandlebarsTemplate(config.actionTitle, rowData) | safeHtml"
                      (click)="onClickAction(config, rowData)"
                    ></span>
                  }
                }
              </div>
            </td>
          }
        </tr>

        @if (!entityData?.length && isApiInProgress && skeletonEnabled) {
          @for (row of skeletonRowIndexes; track row) {
            <tr hlmTableRow data-testid="skeleton-row" [ngStyle]="getRowStyle({}, row)">
              @for (col of columns; track col.value; let colIndex = $index) {
                <td id="td-data">
                  <span
                    class="skeleton_item d-block overflow-hidden"
                    style="max-width: 100%"
                    [style.width]="skeletonCellAt(row, colIndex).width"
                    [style.height]="skeletonCellAt(row, colIndex).height"
                  ></span>
                </td>
              }
              @if (isShowMoreOption) {
                <td class="width-action-row finx-action-col">&nbsp;</td>
              }
              @if (listActions?.enableActionColumn) {
                <td class="width-action-row finx-action-col">&nbsp;</td>
              }
            </tr>
          }
        }

        <!-- No data -->
        <tr hlmTableRow *ngIf="!entityData?.length && !(isApiInProgress && skeletonEnabled)">
          <td hlmTableCell [attr.colspan]="columns.length + 1">
            @if (isApiInProgress) {
              <div [innerHTML]="fetchingContent | safeHtml"></div>
            } @else {
              <div [innerHTML]="emptyTableMsg | safeHtml"></div>
            }
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Paginator -->
  <div class="finx-table-paginator is-center" *ngIf="pagingEnabled && !!entityData?.length">
    <span class="finx-table-paginator-report" *ngIf="!totalListDisabled">{{ currentPageReport }}</span>

    <span class="finx-table-paginator-pages d-flex align-items-center">
      <button
        class="paginator-nav-btn"
        [disabled]="currentPage === 1"
        (click)="goToFirstPage()"
        aria-label="First page"
      >
        &laquo;
      </button>
      <button
        class="paginator-nav-btn"
        [disabled]="currentPage === 1"
        (click)="onPrevPage()"
        aria-label="Previous page"
      >
        &lsaquo;
      </button>

      <button
        class="paginator-page-btn"
        *ngFor="let page of getPageNumbers()"
        [ngClass]="{ active: page === currentPage }"
        (click)="goToPage(page)"
      >
        {{ page }}
      </button>

      <button
        class="paginator-nav-btn"
        [disabled]="isLastPage()"
        (click)="onNextPage()"
        aria-label="Next page"
      >
        &rsaquo;
      </button>
      <button
        class="paginator-nav-btn"
        [disabled]="isLastPage()"
        (click)="goToLastPage()"
        aria-label="Last page"
      >
        &raquo;
      </button>
    </span>

    @if (!totalListDisabled && viewPaginationOptionValue.length > 0) {
      <select
        class="finx-table-rows-select inputField"
        [value]="pageSize"
        (change)="onRowsPerPageChange($event)"
      >
        <option
          *ngFor="let option of viewPaginationOptionValue"
          [value]="option"
          [selected]="option === pageSize"
        >
          {{ option }}
        </option>
      </select>
    }
  </div>
</div>
